import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterTemplateView_template} from "../components/templates/newsletterTemplateView_template";

declare var ko: any;
declare var page: any;

export class newsletter_template_view extends vnModule_knockoutJS {

    protected newsletterTemplateView: newsletterTemplateView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {

        this.newsletterTemplateView = new newsletterTemplateView_template("newsletter_template_view_template", this.viewModel, this);
        return [this.newsletterTemplateView.build()];
    }

    protected getModuleName(): string {

        return "newsletter_template_view_template";
    }

    fillPage() {

        this.getNewsletterTemplatesReferences()
    }

    protected getNewsletterTemplatesReferences() {

        // LOADING : starts
        this.loadingIn(this.newsletterTemplateView.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/references';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onNewsletterTemplatesReferenceRequestReturn;
        this.XHRHdl.execute();
    }

    public onNewsletterTemplatesReferenceRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.newsletterTemplateView.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterTemplateView.setPermissions(responseParsed.permissions)

                obj.getNewsletterTemplateDataForView()
            })
        }
    }

    private getNewsletterTemplateDataForView() {

        this.loadingIn(this.newsletterTemplateView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetNewsletterTemplateDataForView;
        this.XHRHdl.execute();
    }

    private onGetNewsletterTemplateDataForView(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.newsletterTemplateView.setNewsletterTemplateData(responseParsed.template);

            });

            obj.loadingOut(obj.newsletterTemplateView.builtTemplate);
        }
    }

    protected onClickEditNewsletterTemplate(id){

        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/newsletter/templates/edit/" + id + '/')
    }

    protected onClickCancel(){

        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/templates/")
    }
}


// WEBPACK FOOTER //
// ./js/modules/newsletter_template_view.ts